export default __webpack_public_path__ + "static/media/faq_white.bbc941c3.svg";